export const ChartType = {
  VERTICAL_BAR: 'verticalBar',
  HORIZONTAL_BAR: 'horizontalBar',
  LINE: 'line',
  DOUGHNUT: 'doughnut',
};

export const ResultsDrawerState = {
  COLLAPSED: 'COLLAPSED',
  EXPANDED: 'EXPANDED',
};

export const ResultsDrawerSize = {
  DEFAULT: 'DEFAULT',
  WIDE: 'WIDE',
};

export const datasetColors = [
  '#98a5fe',
  '#24d394',
  '#ffc31c',
  '#ff4c59',
  '#3588d1',
  '#d85ee1',
  '#a834bf',
  '#744ba0',
  '#72c8b8',
  '#2a8476',
  '#52c249',
  '#638123',
  '#a6c363',
  '#995c1b',
  '#c7a490',
  '#b12941',
  '#ffd850',
  '#fe8f06',
  '#ff0087',
  '#fe85ad',
];

export const TopicAnalysisStatus = {
  ENGAGEMENT_PRE_OPEN: 'engagementPreOpen',
  ENGAGEMENT_OPEN: 'engagementOpen',
  PENDING: 'pending',
  SUCCESS: 'success',
  EMPTY: 'empty',
  NONE: 'none',
  NEVER: 'never',
};
